// extracted by mini-css-extract-plugin
module.exports = {"container":"eM2W3","suggestionsContainer":"_1zwHp","suggestion":"O95IC","suggestionHighlighted":"_3wojR"};